module.exports = __webpack_public_path__ + "static/media/py.795a9f16.hdr";